// 公用短链处理
import fetchData from '@/api/fetch';
import EventBus from '@/utils/Events';
const POLLING_INTERVAL = 15000; // 15秒
const POLLING_PEER_COUNT = 40;
const ShortLinkMap = new Map();

class ShortLinkServer {
  constructor() {}
  /**
   * 获取短链接
   * api： https://yapi.vhall.com/project/1127/interface/api/55930
   * @param {*} longUrl 长链接地址
   * @param {*} options
   *  description 长链接备注
   *  stripProtocol 默认值1，当为1时候，返回的短链不带协议 示例：t.vhall.com/d77axl；0，返回全连接
   *  origin 来源，业务自定义，可根据不同来源配置确定使用自有短链还是第三方短链,目前统一默认watch_link
   * @param {string|number} pollingKey 轮询唯一标识,不为空不为0时, 表示在状态不是审核通过/拒绝状态情况下需要做轮询检测处理
   * @returns {*}
   * data:{
   *  shortUrl: 短链url(旧值)
   *  compressionCode: 压缩码
   *  status: 状态，0-待处理(审核中) 1-可用 2-失效(服务端自动处理，不返回前端) 3-拒绝
   *  validShortUrl: 可用短链
   * }
   */
  async getShortLink(longUrl, options = { origin: 'watch_link' }, pollingKey = undefined) {
    if (pollingKey) {
      const uniqKey = this._wrapUniqKey(longUrl, pollingKey)
      if (!ShortLinkMap.get(uniqKey)) {
        // 首次发送doing消息
        EventBus.$emit('short_link_progress', {
          longUrl,
          pollingKey,
          count: 0,
          state: 'doing',
        });
      }
    }
    // console.log('resp pollingKey:', pollingKey)
    const params = {
      longUrl,
      stripProtocol: 0,
      ...options
    };
    try {
      const result = await fetchData('getShortLinkUrl', params, {
        'Content-Type': 'application/x-www-form-urlencoded'
      });
      if (result?.code === 200 && result?.data) {
        this._updateShortLinkMap(longUrl, {
          reqOptions: options,
          pollingKey,
          resultData: result.data,
        })
        return {
          longUrl,
          ...result.data
        }
      } else {
        console.error('shortUrl 获取短连接失败:', result);
        this._updateShortLinkMap(longUrl, { reqOptions: options, pollingKey, error: true })
        return { longUrl, status: -1 };
      }
    } catch (error) {
      console.error('shortUrl 获取短连接出错：', error);
      this._updateShortLinkMap(longUrl, { reqOptions: options, pollingKey, error: true })
      return { longUrl, status: -2 };
    } finally {
      this._pollingCheck(longUrl, pollingKey)
    }
  }

  _wrapUniqKey(longUrl, pollingKey) {
    return `${longUrl}_${pollingKey || ''}`
  }

  _updateShortLinkMap(longUrl, obj) {
    const uniqKey = this._wrapUniqKey(longUrl, obj.pollingKey)
    let info = ShortLinkMap.get(uniqKey);
    if (!info) {
      obj.count = 0;
      info = obj;
      ShortLinkMap.set(uniqKey, obj);
    } else {
      if (info.timer) clearTimeout(info.timer)
      info.reqOptions = obj.reqOptions
      info.pollingKey = obj.pollingKey
      info.count++;
      if (obj.resultData) {
        info.resultData = obj.resultData
      }
    }
    return info;
  }

  // 轮询检查
  _pollingCheck(longUrl, pollingKey) {
    const uniqKey = this._wrapUniqKey(longUrl, pollingKey)
    const info = ShortLinkMap.get(uniqKey);
    if (!info?.pollingKey) {
      // 没有开启轮询
      this._shutPolling(info, uniqKey)
      return;
    }
    // 开启了轮询
    const state = info.resultData?.status === 1 ? 'success' : (info.error || info.count > POLLING_PEER_COUNT ? 'failed' : 'doing');
    EventBus.$emit('short_link_progress', {
      longUrl,
      pollingKey,
      count: info.count,
      ...info.resultData,
      state,
    });
    if (state === 'doing') {
      if (info.timer) clearTimeout(info.timer)
      // 定时轮询，获取审核通过的短链
      info.timer = setTimeout(() => {
        console.log('shortUrl 轮询定时器执行 ')
        this.getShortLink(longUrl, info.reqOptions, info.pollingKey)
      }, POLLING_INTERVAL)
    } else {
      this._shutPolling(info, uniqKey)
    }
  }

  _shutPolling(info, uniqKey) {
    // 其它情况处理
    if (info?.timer) {
      clearTimeout(info.timer)
      info.timer = 0;
    }
    ShortLinkMap.delete(uniqKey);
  }
}

// 关键：直接创建并导出实例,单例模式
const shortLinkHelper = new ShortLinkServer();
export default shortLinkHelper;